import React from "react";
import { Navigate } from "react-router-dom";
import { useNotificationsAccess } from "../hooks/useNotificationsAccess";
import LoadingSpinner from "../components/ui/LoadingSpinner";
import NotFoundPage from "../pages/NotFound";

interface NotificationsProtectedRouteProps {
    children: JSX.Element;
    isLoggedIn: boolean;
}

/**
 * Protected route for Notifications that checks:
 * - User is logged in
 * - Company has notifications addon
 */
const NotificationsProtectedRoute: React.FC<NotificationsProtectedRouteProps> = ({ children, isLoggedIn }) => {
    const { hasAccess, loading } = useNotificationsAccess();

    // Show loading state while checking access
    if (loading) {
        return <LoadingSpinner size={50} />;
    }

    // Redirect to login if not logged in
    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    // Show 404 if no access (addon not enabled)
    if (!hasAccess) {
        return <NotFoundPage />;
    }

    return children;
};

export default NotificationsProtectedRoute;
